import { Badge, Card } from 'react-bootstrap';
import Profile from 'components/Layout/Profile';
import { getDataFromLocalStorage, messageTime } from 'utils/helpers';
import { orderBy } from 'lodash';
import SeachInput from 'components/form/SeachInput';
import moment from 'moment';

const SideBar = ({ groupData, setGroupID, groupList, chatRef }) => {
  const { id: groupID } = groupData;
  const displayList = orderBy(groupList, 'updated_at', 'desc');

  const handelGroupClick = (group_id) => {
    if (`${group_id}` !== `${groupID}`) {
      setGroupID(group_id);
    }
  };

  const avatarColors = [
    'bg-new-car',
    'bg-7cff',
    'bg-a35b',
    'bg-5110',
    'bg-C991',
  ];

  const getAvatarColor = (index) => {
    return avatarColors[index % avatarColors.length];
  };

  return (
    <Card className="h-100">
      <div className="chat-user-list iferp-scroll">
        {groupList.length === 0 ? (
          <div className="text-center cpt-100 cpb-100 text-muted">
            No Data Found
          </div>
        ) : (
          groupList?.map((elem, index) => {
            const {
              id,
              last_message,
              user,
              user_id,
              phone_no,
              message_origin,
              updated_at,
            } = elem;

            const displayName = `${user?.first_name || ''} ${
              user?.last_name || ''
            }`;
            const profile_photo_path = user?.profile_photo_path || '';
            const isActive = `${id}` === `${groupID}`;
            const bgColor = getAvatarColor(index);
            const formattedDate = moment
              .utc(updated_at)
              .local()
              .format('DD-MM-YYYY hh:mm A');

            return (
              <div
                className={`chat-user-block d-flex align-items-center cpt-20 cpb-20 cps-18 cpe-18 pointer border-bottom ${
                  isActive ? 'active-sidebar bg-effed' : ''
                } ${groupList.length - 1 === index ? '' : 'border-bottom'}`}
                key={index}
                onClick={() => handelGroupClick(id)}
              >
                <Profile
                  isRounded
                  isS3UserURL
                  text={displayName}
                  size="s-48"
                  url={profile_photo_path}
                  bgColor={bgColor}
                  textColor="color-white"
                />
                <div className="user-details-block ms-3 flex-grow-1 d-flex flex-column overflow-hidden">
                  <div className="d-flex justify-content-between align-items-center text-truncate">
                    <span className="text-15-600 color-raisin-black text-truncate">
                      {displayName ? displayName : phone_no}
                    </span>
                    <span className="text-12-400-15 color-raisin-black flex-shrink-0">
                      {messageTime(formattedDate)}
                    </span>
                  </div>

                  <div className="mt-2 text-13-400 color-black-olive text-truncate">
                    {message_origin === 'AGENT' && 'You:'} {last_message}
                  </div>
                </div>
              </div>
            );
          })
        )}
        <div ref={chatRef} />
      </div>
    </Card>
  );
};

export default SideBar;
